import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';
import * as CommonSelectors from '../selectors/common.selectors';
import * as CommonState from '../reducers/common.reducer';

@Injectable()
export class CommonFacade {
  constructor(private readonly store: Store<CommonState.State>) {}

  selectCommonById$ = (id: string) =>
    this.store.pipe(select(CommonSelectors.selectCommonById(id)));
}
